import React from "react";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export const RenderCustomPrevArrow = ({ onClickHandler }) => (
  <div
    className=""
    onClick={onClickHandler}
    style={{ overflow: "hidden", zIndex: 99, fontWeight: "bold" }}
  >
    <IconButton>
      <ChevronLeftIcon fontSize="medium" />
    </IconButton>
  </div>
);

export const RenderCustomNextArrow = ({ onClickHandler }) => (
  <div
    className=""
    onClick={onClickHandler}
    style={{ overflow: "hidden", zIndex: 99, fontWeight: "bold" }}
  >
    <IconButton>
      <ChevronRightIcon fontSize="medium" />
    </IconButton>
  </div>
);
